// @flow
import * as React from 'react';
import Logo from 'components/Icons/Logo';
import {
  AnalyticsIcon,
  ReviewsIcon,
  QAIcon,
  ContentIcon,
  AccountIcon,
  AdminIcon,
  SupportIcon,
  SocialCollectionIcon,
} from 'components/Icons/Nav';
import { NavLink as RouterNavLink, type ContextRouter } from 'react-router-dom';
import { AuthContext } from 'ducks/auth-context';
import './Nav.scss';

export type NavRouteConfig =
  | 'sep'
  | {
      component?: React.ComponentType<*>,
      render?: () => React.Element<any>,
      path: string,
      exact?: boolean,
      strict?: boolean,
      label?: string,
      navItem?: boolean,
    };

type OwnProps = {|
  contextLabel: string,
  contextRoutes: Array<NavRouteConfig>,
  ...ContextRouter,
|};

type NavProps = OwnProps;

const NavWidth = 200;
const PortalNavWidth = 60;

export const Nav = (props: NavProps) => {
  const { contextLabel, contextRoutes, match } = props;

  return (
    <AuthContext.Consumer>
      {auth => {
        return (
          <nav
            className="w5 min-vh-100 fixed top-0 left-0 bottom-0 bg-dark-gray Nav"
            style={{ width: NavWidth }}
            data-translate={true}
          >
            <div className="h-100 fixed" style={{ width: PortalNavWidth }}>
              <ul className="list pl0 Nav__Portal">
                <li className="db mv3 Nav__Portal__item Nav__Portal__item--home">
                  <NavLink
                    className="h3 flex items-center Nav__Portal__link"
                    to={auth.apps.get('Home')}
                  >
                    <Logo className="db center" style={{ width: '2.5rem' }} />
                  </NavLink>
                </li>
                {[...auth.apps.entries()].slice(1).map(([label, url]) => {
                  const Icon = getAppIcon(label);

                  return (
                    <li className="db Nav__Portal__item" key={url}>
                      <NavLink
                        to={url}
                        className="h2 flex items-center justify-center mv3 link tty dim moon-gray bw2 br bw2 b--dark-gray Nav__Portal__link"
                        activeClassName="b--gold Nav__Portal__link--active"
                      >
                        {Icon && <Icon />}
                      </NavLink>
                    </li>
                  );
                })}
              </ul>
            </div>
            <div
              className="h-100 bg-mid-gray fixed"
              style={{
                marginLeft: PortalNavWidth,
                width: NavWidth - PortalNavWidth,
              }}
            >
              <ul className="list pl0 m0 Nav__App brandon">
                <li className="db mv3 pl3 Nav__App__item">
                  <span className="f4 flex items-center h3 v-mid b white ttu">
                    {contextLabel}
                  </span>
                </li>
                {contextRoutes
                  .filter(route => route === 'sep' || route.navItem)
                  .map(route => {
                    if (route === 'sep') {
                      return (
                        <li className="db Nav__App__item" key={route}>
                          <span className="db mh3 bt b--white-20" />
                        </li>
                      );
                    }
                    const { label, path: to } = route;

                    return (
                      <li className="db Nav__App__item" key={to}>
                        <NavLink
                          to={`${match.url}/${to}`}
                          className="flex items-center pl3 h2 mv3 link moon-gray dim br bw2 br bw2 b--mid-gray fw2 Nav__App__link"
                          activeClassName="b--gold white Nav__App__link--active"
                        >
                          {label}
                        </NavLink>
                      </li>
                    );
                  })}
              </ul>
            </div>
          </nav>
        );
      }}
    </AuthContext.Consumer>
  );
};

function getAppIcon(label: string): ?React.ComponentType<any> {
  switch (label) {
    case 'Reviews':
      return ReviewsIcon;

    case 'QA':
      return QAIcon;

    case 'Moderation':
      return ContentIcon;

    case 'Analytics':
      return AnalyticsIcon;

    case 'Setup':
      return SupportIcon;

    case 'Account':
      return AccountIcon;

    case 'Admin':
      return AdminIcon;

    case 'SocialCollection':
      return SocialCollectionIcon;

    default:
      return null;
  }
}

function NavLink({
  to,
  activeClassName,
  children,
  ...rest
}: {
  activeClassName?: string,
  to: string,
  children: React.Node,
}) {
  const isInternal = /^\/(?!\/)/.test(to);

  if (isInternal) {
    return (
      <RouterNavLink to={to} activeClassName={activeClassName} {...rest}>
        {children}
      </RouterNavLink>
    );
  }

  return (
    <a href={to} {...rest}>
      {children}
    </a>
  );
}

export default Nav;



// WEBPACK FOOTER //
// ./src/pages/__components__/Nav.js